<template>
<el-dialog title="选择零件" width="75%" :append-to-body="true" :visible.sync="viewData.visible" :close-on-click-modal="false" v-loading="loading">
    <div class="user-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="零件编号" prop="partCode">
                <el-input size="small" v-model="dataForm.partCode" placeholder="零件编号" clearable @blur="getDataList()"></el-input>
            </el-form-item>
            <el-form-item label="零件名称" prop="partName">
                <el-input size="small" v-model="dataForm.partName" placeholder="零件名称" clearable @blur="getDataList()"></el-input>
            </el-form-item>
            <el-form-item label="工厂" prop="factory">
                <el-input size="small" v-model="dataForm.factory" placeholder="工厂" clearable @blur="getDataList()"></el-input>
            </el-form-item>
            <!-- <el-form-item label="项目名称" prop="projectName">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList()"></el-input>
            </el-form-item>
            <el-form-item label="车型" prop="carType">
                <el-input size="small" v-model="dataForm.carType" placeholder="车型" clearable @blur="getDataList()"></el-input>
            </el-form-item>
            <el-form-item label="协议结束日期" prop="validityOfContract">
                <el-date-picker v-model="dataForm.validityOfContract" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>-->
                <el-button icon="el-icon-search" size="small" class="cla-user-search" @click="getDataList()">查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" border @selection-change="handleSelectionChange">
               <el-table-column type="selection" width="55">
               </el-table-column>
                <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" min-width="150" label="零件编号">
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" min-width="150" label="零件名称">
                </el-table-column>
                <el-table-column prop="factory" header-align="center" align="left" min-width="100" label="工厂">
                </el-table-column>
                <el-table-column prop="oneCarCount" header-align="center" align="right" min-width="100" label="单车用量">
                </el-table-column>
                <el-table-column prop="priceWithoutTax" header-align="center" align="left" min-width="100" label="未税单价">
                </el-table-column>

                <!--<el-table-column prop="contractStartDate" header-align="center" align="left" min-width="100" label="合同起始日期">
                </el-table-column>
                <el-table-column prop="contractEndDate" header-align="center" align="left" min-width="100" label="合同结束日期">
                </el-table-column>
                <el-table-column prop="projectName" header-align="center" align="left" min-width="120" label="项目名称">
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" width="120" label="车型">
                </el-table-column>-->
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
            </el-pagination>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">

            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <!-- 选择供应商确定添加到供应商列表 -->
            <el-button size="small" type="primary" @click="confirm()">
                确认
            </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    USER_TYPE,
    SUPPLY_RFQ_STATUS_VALUE,
    SUPPLY_TYPE_VALUE,
    getSUPPLY_TYPE_VALUE,
    DIALOG_CLOSED_TYPE
} from '@/utils/const';
import {
    getPriceAgreementPartList
} from "@/controller/priceAgreement";
import {
    createRfqSupplierBatch
} from "@/controller/rfq";
export default {
    props: {
        basicFormData: Object,
    },
    data() {
        return {
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            dialogFormVisible: false,
            dataForm: {
                priceAgreementId: '',
                partCode: '',
                partName: '',
                factory: '',
                projectName: '',
                carType: '',
                validityOfContract: '',
                contractStartDate: '',
                contractEndDate: ''
            },
            dataList: [],
            ids: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            dataListLoading: false,
            dataListSelections: [],
            SUPPLY_RFQ_STATUS_VALUE: SUPPLY_RFQ_STATUS_VALUE,
            SUPPLY_TYPE_VALUE: SUPPLY_TYPE_VALUE,
            getSUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE,
            currentFactor: '',//单选框的v-model值
            selectPartList: [],
        }
    },
    mounted() {},
    activated() {
        this.getDataList()
    },
    methods: {
        open(priceAgreementId) {
            this.viewData.visible = true
            this.pageSize = 10
            this.pageIndex = 1
            this.dataForm.priceAgreementId = priceAgreementId
            this.getDataList()
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }

            this.onClosed({
                option,
                sender: this,
                data: "OK",
            });
            this.viewData.visible = false;
        },
        confirm() {
            console.log("this.selectPartList===="+this.selectPartList)
            if (this.selectPartList.length == 0) {
                this.$message({
                    message: '请至少选择一条数据添加',
                    type: 'warning'
                })
                return false
            } else {
                //将选择的数据添加到零件列表
                this.$emit('refreshPartList', this.selectPartList)
                this.viewData.visible = false;
            }
        },
        // 获取数据列表
        getDataList() {
            if(this.dataForm.validityOfContract && this.dataForm.validityOfContract.length === 2) {
                this.dataForm.contractStartDate = this.dataForm.validityOfContract[0]
                this.dataForm.contractEndDate = this.dataForm.validityOfContract[1]
            } else {
                this.dataForm.contractStartDate = null
                this.dataForm.contractEndDate = null
            }
            this.dataListLoading = true,
                getPriceAgreementPartList({
                    pageNo: this.pageIndex,
                    pageSize: this.pageSize,
                    ...this.dataForm
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        console.log('this.dataList', this.dataList)
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
        },
        handleSelectionChange(e) {
          // console.log(e)
          this.selectPartList = e.map((item) => item);
        },

        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        // 新增
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id)
            })
        },
        // 删除
        deleteHandle(id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUser(ids).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },

    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}

.fr {
    float: right;
}

.mt15 {
    margin-top: 15px;
}

.mb {
    margin-bottom: 15px;
}
</style>
